import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface UploadState {
  progress: number
  status: string // waiting, uploading, success, failed
  open: boolean
  filename: string
  remainingTime: number
  upgradeRuleId: string
  upgradeStatus: { status: string; type: string } // waiting, uploading, success, failed
  globalLoading: boolean
}

const initialState: UploadState = {
  progress: 0,
  status: 'waiting',
  open: false,
  filename: '',
  remainingTime: 0,
  upgradeRuleId: '',
  upgradeStatus: { status: 'waiting', type: '' },
  globalLoading: false,
}

const uploadSlice = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    setProgress: (state, action: PayloadAction<number>) => {
      state.progress = action.payload
    },
    setStatus: (state, action: PayloadAction<string>) => {
      state.status = action.payload
    },
    setOpen: (state, action: PayloadAction<boolean>) => {
      state.open = action.payload
    },
    setFilename: (state, action: PayloadAction<string>) => {
      state.filename = action.payload
    },
    setRemainingTime: (state, action: PayloadAction<number>) => {
      state.remainingTime = action.payload
    },
    setUpgradeRuleId: (state, action: PayloadAction<string>) => {
      state.upgradeRuleId = action.payload
    },
    setUpgradeStatus: (state, action: PayloadAction<{ status: string; type: string }>) => {
      state.upgradeStatus = action.payload
    },
    setGlobalLoading: (state, action: PayloadAction<boolean>) => {
      state.globalLoading = action.payload
    },
  },
})

export const {
  setProgress,
  setStatus,
  setOpen,
  setFilename,
  setRemainingTime,
  setUpgradeRuleId,
  setUpgradeStatus,
  setGlobalLoading,
} = uploadSlice.actions

export default uploadSlice.reducer
